import React, { useState } from 'react';

import { OperationProblem } from '../../../gamma-api';
import { getTranslateFunc } from '../../utils/stringUtil';
import IbModal from '../common/IbModal';
import IbIcon from '../common/IbIcon';
import IbButton from '../common/IbButton';
import StatusModal from '../common/StatusInfo/StatusModal';
import { StatusInfoState } from '../common/StatusInfo/types';

import {
  MAIN_CLASS_NAME,
  CONTENT_CLASS_NAME,
  ERROR_CLASS_NAME,
  ICON_CLASS_NAME,
  HEADER_CLASS_NAME,
  DESCRIPTION_CLASS_NAME,
} from './const';

interface IErrorPanelProps {
  group: string;
  visible: boolean;
  loading?: boolean;
  problem?: OperationProblem | null;
  onRestart?: () => void;
  onClose?: () => void;
}

const ErrorPanel: React.FC<IErrorPanelProps> = ({ group, visible, loading, problem, onRestart, onClose }) => {
  const [status, setStatus] = useState<StatusInfoState>();

  const translate = getTranslateFunc(`${group}: Error:`);

  const onErrorClick = () => {
    setStatus(StatusInfoState.Error);
  };

  const onErrorClose = () => {
    setStatus(undefined);
  };

  const onRestartClick = () => {
    setStatus(undefined);
    onRestart?.();
  };

  return (
    <IbModal className={MAIN_CLASS_NAME} loading={loading} visible={visible} onCancel={onClose}>
      <div className={`${CONTENT_CLASS_NAME} ${ERROR_CLASS_NAME}`}>
        <div className={ICON_CLASS_NAME}>
          <IbIcon iconName="info" size={64} />
        </div>
        <div className={HEADER_CLASS_NAME}>
          <div>{translate('Header: Line-1')}</div>
          <div>{translate('Header: Line-2')}</div>
          <IbButton type="link" onClick={onErrorClick}>
            {translate('Buttons: Error')}
          </IbButton>
        </div>
        <div className={DESCRIPTION_CLASS_NAME}>
          <IbButton type="fill" onClick={onRestartClick}>
            {translate('Buttons: Restart')}
          </IbButton>
        </div>
      </div>
      <StatusModal
        description={translate('Info: Description')}
        problem={problem}
        rolling={false}
        status={status}
        subtitle={translate('Info: Subtitle')}
        title={translate('Info: Title')}
        visible={status === StatusInfoState.Error}
        onClose={onErrorClose}
        onRestart={onRestartClick}
      />
    </IbModal>
  );
};

export default ErrorPanel;
